const INSTALLATION_KEY = 'pill_reminder_native_installation';

// A backup can copy the WebView UUID and account cache. A native, non-backed-up marker
// distinguishes a restored installation. Do not delete the old server data.
export function reconcileNativeInstallation(nativeId) {
    if (!nativeId || typeof nativeId !== 'string') return false; // Older binaries remain compatible.
    const previous = localStorage.getItem(INSTALLATION_KEY);
    if (previous && previous !== nativeId) {
        for (const key of Object.keys(localStorage)) {
            if (key.startsWith('pill_reminder_')) localStorage.removeItem(key);
        }
        localStorage.setItem('pill_reminder_installation_restored', 'true');
    }
    localStorage.setItem(INSTALLATION_KEY, nativeId);
    return Boolean(previous && previous !== nativeId);
}
